import { memo } from "react";
import { useLocalization } from "@fluent/react";

const PositivePayItem = () => {
  const { l10n } = useLocalization();
  return (
    <button
      type="button"
      className="button--reset topMenu-link"
      onClick={() => {
        window.location.href = "/positive_pay";
      }}
    >
      {l10n.getString("nav-positive-pay-link", null, "Positive Pay")}
    </button>
  );
};

export default memo(PositivePayItem);
